import DinamicCrudCustomConsulta from './DinamicCrudCustomConsulta'
import enhancer from './DinamicCrudCustomConsulta.enhancer'

export default enhancer(DinamicCrudCustomConsulta)


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/components/DinamicCrudCustomConsulta/index.js